export default "__VITE_PUBLIC_ASSET__fcf6c709__"